// Chat.js
import React, { useContext } from 'react';
import { ChatbotContext } from '../../Context/ChatbotContext';
import { ChatbotStateContext } from '../../Context/ChatbotStateContext';
import fondoChat from '../../assets/chatbot/Fondo.svg';
import { IoSend } from 'react-icons/io5';
import { IoMdCloseCircle } from 'react-icons/io';
import { FaUser } from "react-icons/fa";
import logoblanco from '../../assets/chatbot/Logo_B2.svg'
import iconBot from '../../assets/chatbot/iconBot.svg';

const Chat = () => {

  const { isChatOpen, toggleChat } = useContext(ChatbotContext);
  const {
    messages,
    inputValue,
    setInputValue,
    isLoading,
    handleSendMessage,
    setCurrentStep,
    userId,
    setUserId,
    sessionId,
    setSessionId,
  } = useContext(ChatbotStateContext);
  const handleCloseChat = () => {
    // Si el usuario está logueado, conservamos el step en 'chat' en localStorage
    if (userId && sessionId) {
      localStorage.setItem('currentStep', 'chat');
    }
    // cierra/minimiza la ventana
    toggleChat();
  };

  return (
    <div id="chatbot-container" className={`chatbot-container ${isChatOpen ? 'chatbot-expanded' : ''}`}>
      <div id="chatbot-toggle" className={`chatbot-header ${isChatOpen ? 'chatbot-header-open' : 'chatbot-header-collapsed'}`}
        onClick={() => {
          // si no hay userId/sessionId -> 'welcome'
          if (!isChatOpen) {
            if (!userId || !sessionId) {
              setCurrentStep('welcome');
            }
          }
          toggleChat();
        }}
      >
              {/* Esto siempre está, tanto abierto como colapsado */}
       <div className={`chatbot-toggle-logo ${isChatOpen ? 'hidden' : 'block'}`}>
             <img src={logoblanco} alt="Logo Blanco" className="h-12 w-12" />
           </div>
        {isChatOpen && (
          <div className="flex items-center w-full m-0">
            <img src={logoblanco} alt="Bot Icon" className="chatbot-header-icon" />
            <div className="flex flex-col items-left w-full px-4 py-0">
              <h2 className="text-white font-semibold">Hola, Soy YARMIS</h2>
              <p className="text-sm">Estoy aquí para ayudarte con lo que necesites.</p>
            </div>
            <IoMdCloseCircle className="btn-close" onClick={handleCloseChat} />

          </div>
        )}
      </div>

      {isChatOpen && (
        <div id="chatbot-window" className="chatbot-window">
          <div id="chatbot-messages" className="chatbot-messages" style={{ backgroundImage: `url(${fondoChat})` }}>
            <div className="h-full overflow-y-auto flex flex-col">
              {messages.map((msg, index) => (
                <div key={index} className={`message-container ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`}>
                  {msg.sender === 'bot' && (
                    <>
                      <div className="message-icon bot-icon">
                        <img src={iconBot} alt="Bot Icon" />
                      </div>
                      <div className="message-bot" dangerouslySetInnerHTML={{ __html: msg.message }}></div>
                    </>
                  )}

                  {msg.sender === 'user' && (
                    <>
                      <div className="message-user">{msg.message}</div>
                      <div className="message-icon user-icon">
                        <FaUser className="user" />
                      </div>
                    </>
                  )}
                </div>
              ))}


              {isLoading && (
                <div className="message-container justify-start">
                  <div className="message-icon bot-icon">
                    <img src={iconBot} alt="Bot Icon" />
                  </div>
                  <div className="loading-dots-container">
                    <div className="dot"></div>
                    <div className="dot delay-100"></div>
                    <div className="dot delay-200"></div>
                  </div>
                </div>
              )}
            </div>
          </div>


          <div id="user-input-container" className="chatbot-input-container">
            <input
              type="text"
              placeholder="Escribe un mensaje..."
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleSendMessage();
                }
              }}
              className="chatbot-input placeholder:text-xs"
            />
            <IoSend onClick={handleSendMessage} className="chatbot-send-icon" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Chat;